<template>
  <div class="architecture-page">

    <!-- Banner部分 -->
    <div class="architecture-banner">
      <div class="banner-content">
        <h1 class="banner-title">{{ $t('archVocational.banner.title') }}</h1>

      </div>
    </div>

    <!-- 介绍部分 -->
    <div class="architecture-intro">
      <div class="intro-container">
        <div class="intro-text">
          <h2 class="intro-title">{{ $t('archVocational.intro.title') }}</h2>
          <p class="intro-description">{{ $t('archVocational.intro.desc') }}</p>
        </div>
        <div class="intro-image">
          <img src="@/assets/architecture/intro.png"
               :alt="$t('archVocational.intro.imageAlt')" />
        </div>
      </div>
    </div>

    <!-- 场景板块 -->
    <div class="scenes-section">
      <!-- 第一个场景 - 带背景色 -->
      <div class="scene-item scene-featured">
        <h3 class="scene-title">{{ $t('archVocational.scenesFeatured.title') }}</h3>
        <p class="scene-description">{{ $t('archVocational.scenesFeatured.desc') }}</p>
      </div>

      <!-- 其他场景 -->
      <div class="scene-item"
           v-for="(scene, index) in scenes"
           :key="index">
        <div class="scene-content"
             :class="{ 'expanded': scene.expanded }">
          <div class="scene-image">
            <img :src="scene.image"
                 :alt="scene.title">
          </div>
          <div class="scene-info">
            <div class="scene-header">
              <h3>{{ scene.title }}</h3>
              <el-button class="toggle-btn"
                         type="text"
                         @click="toggleScene(index)">
                <i :class="scene.expanded ? 'el-icon-minus' : 'el-icon-plus'"></i>
              </el-button>
            </div>
            <p v-show="scene.expanded"
               class="scene-detail">{{ scene.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 解决方案板块 -->
    <div class="solutions-section">
      <h2 class="solutions-title">{{ $t('archVocational.solutions.title') }}</h2>
      <div class="solutions-container">
        <!-- 左侧导航 -->
        <div class="solutions-nav">
          <div v-for="(item, index) in solutions"
               :key="index"
               class="nav-item"
               :class="{ 'active': currentSolution === index }"
               @click="currentSolution = index">
            {{ item.title }}
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="solutions-content">
          <img :src="solutions[currentSolution].image"
               :alt="solutions[currentSolution].title">
        </div>
      </div>
    </div>

    <!-- 产品模块Banner -->
    <div class="products-banner">
      <div class="banner-overlay banner-left">
        <div class="banner-left-text">
          <div class="banner-left-title">{{ $t('archVocational.bannerLeft.title') }}</div>
          <div class="banner-left-subtitle">{{ $t('archVocational.bannerLeft.subtitle') }}</div>
        </div>
      </div>
    </div>

    <!-- 产品模块 -->
    <div class="products-module">
      <!-- 导航栏 -->
      <div class="products-nav">
        <div class="nav-slider"
             :style="{ transform: `translateX(${currentProduct * 100}%)` }"></div>
        <div v-for="(item, index) in productTabs"
             :key="index"
             class="nav-tab"
             :class="{ 'active': currentProduct === index }"
             @click="currentProduct = index">
          {{ item.title }}
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="product-content">
        <div class="product-info">
          <h3 class="product-title">{{ productTabs[currentProduct].title1 }}</h3>
          <p class="product-description">{{ productTabs[currentProduct].description }}</p>
        </div>
        <div class="product-image">
          <img :src="productTabs[currentProduct].image"
               :alt="productTabs[currentProduct].title">
        </div>
      </div>
    </div>

    <!-- 学习板块 -->
    <div class="learning-section">
      <h2 class="solutions-title">{{ $t('archVocational.learning.title') }}</h2>
      <div class="learning-container">
        <!-- 左侧轮播图 -->
        <div class="carousel-wrapper">
          <el-carousel trigger="click"
                       height="500px"
                       :autoplay="true">
            <el-carousel-item v-for="(item, index) in carouselImages"
                              :key="index">
              <img :src="item.url"
                   :alt="item.alt">
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 右侧内容 -->
        <div class="content-wrapper">
          <div class="content-groups">
            <div class="content-group"
                 v-for="(group, index) in learningGroups"
                 :key="index">
              <h3>{{ group.title }}</h3>
              <p>
                <span v-for="(line, lineIndex) in group.lines"
                      :key="`group-${index}-line-${lineIndex}`">
                  {{ line }}<br v-if="lineIndex < group.lines.length - 1">
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ArchitectureH',
  components: {

  },
  data() {
    return {
      carouselAssets: [
        { url: require('@/assets/architecture/skill1.png') },
        { url: require('@/assets/architecture/skill2.png') },
        { url: require('@/assets/architecture/skill3.png') }
      ],
      scenesAssets: [
        { image: require('@/assets/architecture/scene1.png') },
        { image: require('@/assets/architecture/scene2.png') },
        { image: require('@/assets/architecture/scene3.png') }
      ],
      scenesState: [false, false, false],
      currentSolution: 0,
      currentProduct: 0,
      solutionsAssets: [
        { image: require('@/assets/architecture/solution1.png') },
        { image: require('@/assets/architecture/solution2.png') },
        { image: require('@/assets/architecture/solution3.png') },
        { image: require('@/assets/architecture/solution4.png') },
        { image: require('@/assets/architecture/solution5.png') }
      ],
      productTabAssets: [
        { image: require('@/assets/architecture/dev1.png') },
        { image: require('@/assets/architecture/dev2.png') },
        { image: require('@/assets/architecture/dev3.png') }
      ]
    }
  },
  computed: {
    archVocationalCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages =
        this.$i18n && this.$i18n.getLocaleMessage
          ? this.$i18n.getLocaleMessage(locale)
          : {}
      return messages.archVocational || {}
    },
    carouselImages() {
      const list = (this.archVocationalCopy.carousel && this.archVocationalCopy.carousel.items) || []
      return list.map((item, index) => {
        const asset = this.carouselAssets[index] || {}
        return {
          url: asset.url || '',
          alt: item.alt || ''
        }
      })
    },
    scenes() {
      const list = (this.archVocationalCopy.scenes && this.archVocationalCopy.scenes.items) || []
      return list.map((item, index) => {
        const asset = this.scenesAssets[index] || {}
        return {
          title: item.title || '',
          description: item.desc || '',
          image: asset.image || '',
          expanded: this.scenesState[index] || false
        }
      })
    },
    solutions() {
      const list = (this.archVocationalCopy.solutions && this.archVocationalCopy.solutions.items) || []
      return list.map((item, index) => {
        const asset = this.solutionsAssets[index] || {}
        return {
          title: item.title || '',
          image: asset.image || ''
        }
      })
    },
    productTabs() {
      const list = (this.archVocationalCopy.products && this.archVocationalCopy.products.tabs) || []
      return list.map((item, index) => {
        const asset = this.productTabAssets[index] || {}
        return {
          title: item.title || '',
          title1: item.title1 || '',
          description: item.description || '',
          image: asset.image || ''
        }
      })
    },
    learningGroups() {
      const list = (this.archVocationalCopy.learning && this.archVocationalCopy.learning.groups) || []
      return list.map((item) => ({
        title: item.title || '',
        lines: item.lines || []
      }))
    }
  },
  methods: {
    toggleScene(index) {
      this.$set(this.scenesState, index, !this.scenesState[index])
    }
  }
}
</script>

<style scoped>
.architecture-page {
  width: 100%;
  overflow: hidden;
}

/* Banner样式 */
.architecture-banner {
  height: 95vh;
  width: 100%;
  background: url("@/assets/architecture/banner.png");
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}

.banner-content {
  text-align: center;
  color: #fff;
  z-index: 99;
}

.banner-content .banner-title {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 20px;
}

.banner-subtitle {
  font-size: 24px;
  opacity: 0.9;
}

/* 介绍部分样式 */
.architecture-intro {
  padding: 100px 0;
  background: #fff;
}

.intro-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.intro-text {
  flex: 1;
  max-width: 500px;
}

.intro-title {
  font-size: 34px;
  color: #333;
  margin-bottom: 30px;
}

.intro-description {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.intro-image {
  flex: 1;
  max-width: 600px;
}

.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

/* 场景板块样式 */
.scenes-section {
  padding: 80px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #f4f6fa;
  gap: 20px;
  width: 100%;
}

.scene-item {
  position: relative;
  background: #f5f5f5;
  width: 455px;
  height: 553px;
}
/* 联系我们表单样式 */
.contact-section {
  background: #f7f7f7;
  padding: 60px 0;
  margin-top: 60px;
}

.contact-title {
  text-align: center;
  margin-bottom: 40px;
}

.contact-title h2 {
  font-size: 34px;
  /* font-weight: 600; */
  font-weight: normal !important;
  color: #333;
  margin-bottom: 10px;
}

.contact-title p {
  font-size: 16px;
  color: #666;
  margin: 0;
  font-weight: normal !important;
}

.contact-form-wrapper {
  max-width: 600px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .contact-section {
    padding: 40px 0;
    margin-top: 40px;
  }

  .contact-title h2 {
    font-size: 24px;
  }

  .contact-title p {
    font-size: 14px;
  }
}
/* 第一个场景特殊样式 */
.scene-featured {
  background-color: #2ea2fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  margin-left: 20px;
  color: #fff;
  width: 415px;
  height: 553px;
}

.scene-featured .scene-title {
  font-size: 24px;
  margin-bottom: 30px;
  line-height: 1.4;
  font-weight: 500;
  width: 300px;
}

.scene-featured .scene-description {
  font-size: 16px;
  line-height: 1.6;
  width: 300px;
}

/* 其他场景样式 */
.scene-content {
  display: flex;
  flex-direction: column;
}

.scene-image {
  width: 100%;
  height: 0;
  padding-bottom: 80%;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.scene-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scene-info {
  padding: 20px;
}

.scene-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.scene-header h3 {
  font-size: 20px;
  color: #000;
  margin: 0;
}

.toggle-btn {
  padding: 0;
  font-size: 15px;
}

.toggle-btn i {
  color: #ffffff;
  background: #2ea2fa;
  border-radius: 50%;
  padding: 5px;
}

.scene-detail {
  margin-top: 15px;
  color: #333;
  line-height: 1.6;
}

/* 展开状态 */
.expanded .scene-image {
  padding-bottom: 0;
  height: 0;
}

/* 解决方案板块样式 */
.solutions-section {
  padding: 80px 0;
}

.solutions-title {
  text-align: center;
  font-size: 34px;
  color: #000;
  margin-bottom: 60px;
}

.solutions-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
  padding: 0 20px;
}

.solutions-nav {
  width: 443px;
  background: #f5f5f5;
  border-radius: 24px;
  overflow: hidden;
  height: 424px;
}

.nav-item {
  padding: 0 30%;
  font-size: 18px;
  display: flex;
  align-items: center;
  height: calc(424px / 5);
  color: #555;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-item.active {
  /* background: rgba(255, 255, 255, 0.5); */
  color: #000;
  font-weight: 600;
}

.solutions-content {
  flex: 1;
}

.solutions-content img {
  width: 100%;
  height: 424px;
  object-fit: cover;
  border-radius: 24px;
}

/* 产品模块Banner样式 */
.products-banner {
  height: 600px;
  width: 100%;
  background: url("@/assets/architecture/aibanner.png") no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 80px;
}

.banner-overlay {
  padding: 60px 40px;
  border-radius: 16px;
  text-align: center;
  max-width: 800px;
  margin: 0 20px;
}

.banner-left {
  margin-left: -680px;
}

.banner-left-text {
  text-align: left;
}

.banner-left-title,
.banner-left-subtitle {
  font-size: 34px;
  color: #333;
  font-weight: normal;
}

.banner-text h2 {
  font-size: 48px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: bold;
}

.banner-text p {
  font-size: 20px;
  color: #fff;
  line-height: 1.6;
  opacity: 0.9;
}

/* 产品模块样式 */
.products-module {
  padding: 80px 0;
  max-width: 1200px;
  margin: 0 auto;
}

/* 导航栏样式 */
.products-nav {
  width: 834px;
  height: 78px;
  margin: 0 auto 60px;
  display: flex;
  background: #f5f5f5;
  border-radius: 39px;
  padding: 0;
  overflow: hidden;
  position: relative;
}

.nav-slider {
  position: absolute;
  width: calc(100% / 3);
  height: 100%;
  background: #2ea2fa;
  border-radius: 39px;
  transition: transform 0.3s ease;
  z-index: 1;
}

.nav-tab {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  color: #333;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.nav-tab.active {
  color: #fff;
}

/* 内容区域样式 */
.product-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  padding: 0 20px;
}

.product-info {
  flex: 1;
  max-width: 500px;
}

.product-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 30px;
}

.product-description {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.product-image {
  flex: 1;
  max-width: 500px;
}

.product-image img {
  width: 100%;
  height: auto;
}

/* 学习板块样式 */
.learning-section {
  background: #f5f5f5;
  padding: 80px 0;
}

.learning-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  padding: 0 20px;
}

/* 轮播图样式 */
.carousel-wrapper {
  width: 643px;
  height: 500px;
}

.carousel-wrapper :deep(.el-carousel__container) {
  height: 100%;
}

.carousel-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 内容样式 */
.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content-groups {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content-group h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.content-group p {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .intro-container {
    flex-direction: column;
    text-align: center;
  }

  .intro-text {
    max-width: 100%;
  }

  .intro-image {
    max-width: 100%;
  }

  .scenes-section {
    grid-template-columns: 1fr;
    padding: 40px 20px;
  }

  .solutions-container {
    flex-direction: column;
  }

  .solutions-nav {
    width: 100%;
  }

  .solutions-content img {
    height: auto;
  }

  .products-nav {
    width: 100%;
    padding: 0 20px;
  }

  .product-content {
    flex-direction: column;
  }

  .product-info,
  .product-image {
    max-width: 100%;
  }

  .learning-container {
    flex-direction: column;
  }

  .carousel-wrapper {
    width: 100%;
  }
}

@media (max-width: 768px) {
  /* Banner部分移动端适配 */
  .architecture-banner {
    height: 230px !important;
  }

  .banner-content {
    margin: 0 auto;
  }

  .banner-content .banner-title {
    font-size: 36px !important;
    margin-top: 10% !important;
  }

  .banner-subtitle {
    font-size: 18px !important;
  }

  /* 介绍部分移动端适配 */
  .architecture-intro {
    padding: 40px 0 !important;
  }

  .intro-container {
    flex-direction: column !important;
    gap: 30px !important;
    padding: 0 15px !important;
    text-align: center !important;
  }

  .intro-text {
    max-width: 100% !important;
    order: 1 !important;
  }

  .intro-title {
    font-size: 32px !important;
    margin-bottom: 20px !important;
  }

  .intro-description {
    font-size: 14px !important;
    text-align: left !important;
    max-width: 374px !important;
    margin: 0 auto !important;
  }

  .intro-image {
    max-width: 100% !important;
    order: 2 !important;
    display: flex !important;
    justify-content: center !important;
  }

  .intro-image img {
    width: 374px !important;
    height: 249px !important;
    object-fit: cover !important;
    border-radius: 8px !important;
  }

  /* 场景板块移动端水平滑动布局 */
  .scenes-section {
    padding: 40px 0 !important;
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    gap: 20px !important;
    width: 100% !important;
    height: 433px !important;
    box-sizing: border-box !important;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .scenes-section::-webkit-scrollbar {
    display: none;
  }

  .scene-item {
    flex: 0 0 320px !important;
    width: 320px !important;
    height: 433px !important;
    scroll-snap-align: start;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .scene-item:first-child {
    margin-left: 15px !important;
  }

  .scene-item:last-child {
    margin-right: 15px !important;
  }

  .scene-featured {
    width: 320px !important;
    height: 433px !important;
    padding: 40px 20px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .scene-featured .scene-title {
    font-size: 24px !important;
    width: 100% !important;
    text-align: center !important;
  }

  .scene-featured .scene-description {
    width: 100% !important;
    text-align: center !important;
    font-size: 14px !important;
  }

  .scene-content {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }

  .scene-image {
    width: 100% !important;
    height: 60% !important;
    padding-bottom: 0 !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .scene-image img {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }

  .scene-info {
    padding: 15px !important;
    height: 40% !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .scene-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 10px !important;
  }

  .scene-header h3 {
    font-size: 18px !important;
    margin: 0 !important;
  }

  .scene-detail {
    font-size: 13px !important;
    line-height: 1.4 !important;
    flex: 1 !important;
    overflow: hidden !important;
  }

  /* 解决方案板块移动端适配 */
  .solutions-section {
    padding: 40px 15px !important;
  }

  .solutions-title {
    font-size: 30px !important;
    margin-bottom: 30px !important;
    text-align: center !important;
  }

  .solutions-container {
    flex-direction: column !important;
    gap: 20px !important;
    padding: 0 !important;
    max-width: 100% !important;
  }

  .solutions-nav {
    width: 100% !important;
    height: auto !important;
    background: transparent !important;
    border-radius: 0 !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    display: flex !important;
    flex-direction: row !important;
    gap: 15px !important;
    padding: 0 !important;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .solutions-nav::-webkit-scrollbar {
    display: none;
  }

  .nav-item {
    flex: 0 0 200px !important;
    width: 200px !important;
    height: 50px !important;
    padding: 0 20px !important;
    background: #f5f5f5 !important;
    border-radius: 25px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: nowrap !important;
    font-size: 20px !important;
    text-align: center !important;
    scroll-snap-align: start;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .nav-item:first-child {
    margin-left: 0 !important;
  }

  .nav-item:last-child {
    margin-right: 0 !important;
  }

  .nav-item.active {
    /* background: rgba(255, 255, 255, 0.5) !important; */
    color: #333 !important;
    font-weight: bold !important;
  }

  .solutions-content {
    flex: none !important;
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin-top: 20px !important;
  }

  .solutions-content img {
    width: 374px !important;
    height: 219px !important;
    object-fit: cover !important;
    border-radius: 24px !important;
  }

  /* 产品模块Banner移动端适配 */
  .products-banner {
    height: 400px !important;
    margin-bottom: 40px !important;
  }

  .banner-overlay {
    padding: 40px 20px !important;
    margin: 0 15px !important;
  }

  .banner-text h2 {
    font-size: 32px !important;
    margin-bottom: 15px !important;
  }

  .banner-text p {
    font-size: 16px !important;
  }

  /* 产品模块移动端适配 */
  .products-module {
    padding: 40px 15px !important;
  }

  .products-nav {
    width: calc(100% - 30px) !important;
    margin: 0 auto 40px !important;
    padding: 0 !important;
    height: 60px !important;
  }

  .nav-tab {
    padding: 0 10px !important;
    font-size: 16px !important;
  }

  .product-content {
    flex-direction: column !important;
    gap: 30px !important;
    padding: 0 !important;
  }

  .product-info {
    max-width: 100% !important;
    text-align: center !important;
  }

  .product-title {
    font-size: 24px !important;
    margin-bottom: 20px !important;
  }

  .product-description {
    font-size: 14px !important;
    text-align: left !important;
  }

  .product-image {
    max-width: 100% !important;
    height: auto !important;
    display: flex !important;
    justify-content: center !important;
  }

  .product-image img {
    width: 374px !important;
    height: auto !important;
    object-fit: cover !important;
  }

  /* 学习板块移动端适配 */
  .learning-section {
    padding: 40px 15px !important;
  }

  .learning-container {
    flex-direction: column !important;
    gap: 30px !important;
    padding: 0 !important;
    display: flex !important;
  }

  .content-wrapper {
    flex: none !important;
    order: 1 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .solutions-title {
    font-size: 32px !important;
    width: 100% !important;
    text-align: center !important;
    margin-bottom: 30px !important;
    order: 1 !important;
  }

  .content-groups {
    gap: 20px !important;
    order: 2 !important;
    margin-bottom: 30px !important;
  }

  .carousel-wrapper {
    width: 100% !important;
    height: 300px !important;
    order: 2 !important;
  }

  .content-group h3 {
    font-size: 18px !important;
    margin-bottom: 10px !important;
  }

  .content-group p {
    font-size: 14px !important;
  }
}

@media (max-width: 1768px) {
  .scene-item {
    width: 315px !important;
    height: 453px;
  }
}

@media (max-width: 768px) {
  .scene-featured {
    padding: 40px 20px;
  }

  .scene-featured .scene-title {
    font-size: 24px;
  }
}
</style> 
